import React, { Component } from 'react';
import {
  TabPane, Label, Input, FormGroup, Form, Button
} from 'reactstrap';
import { CollapsibleCard } from '../shared/CollapsibleCard';
import { PasswordField } from '../shared/PasswordField';
import { UserDataService } from '../services/UserDataService';

export class AccountInformation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      userQuestions: {}
    };
    this.userDataService = new UserDataService();
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeSecurityQuestions = this.handleChangeSecurityQuestions.bind(this);
    this.handleChangeInfo = this.handleChangeInfo.bind(this);
    this.prepareSecurityQuestions = this.prepareSecurityQuestions.bind(this);
    this.prepareSecurityQuestions();
  }

  handleChangeInfo(e) {
    e.preventDefault();
    var formData = new FormData(e.target);
    var newInfo = {
      username: formData.get('username'),
      email: formData.get('email')
    };
    this.userDataService.updateUsernameEmail(newInfo).then((data) => {
      if (data && data.status === 200)
        window.alert('Successfully changed Username and Email.');
      else
        window.alert('Could not update user information');
    });
  }

  handleChangePassword(e) {
    var formData = new FormData(e.target);
    this.userDataService.updatePassword(formData.get('password'), formData.get('confirmPassword'))
      .then((data) => {
        //TODO: make a user notification service that pops up a toast notification instead of window.alert
        if (data && data.status === 200)
          window.alert('Password updated successfully.');
        else
          window.alert('Could not update password. ' +
            'Please ensure that the passwords are the same and that they conform to password standards.');
      });
    e.preventDefault();
  }

  handleChangeSecurityQuestions(e) {
    e.preventDefault();
    var formData = new FormData(e.target);
    var questions = {
      question1Id: formData.get('securityQuestion1'),
      question2Id: formData.get('securityQuestion2'),
      question3Id: formData.get('securityQuestion3'),
      answer1: formData.get('securityResponse1'),
      answer2: formData.get('securityResponse2'),
      answer3: formData.get('securityResponse3')
    };
    this.userDataService.updateSecurityQuestions(questions).then(data => {
        window.alert('Security questions updated successfully.'); // BUG FIX 814
    });
  }

  prepareSecurityQuestions() {
    Promise.all([
      this.userDataService.getSecurityQuestions(),
      this.userDataService.getSecurityQuestionsForUser()
    ])
      .then(values => {
        this.setState({
          questions: values[0].questions,
          userQuestions: values[1].questions
        })
      });
  }

  render() {
    return (
      <TabPane tabId="1">
        <CollapsibleCard title='Sign-in'>
          <Form onSubmit={this.handleChangeInfo}>
            <FormGroup>
              <Label>User Name</Label>
              <Input defaultValue={this.props.user.username} key={this.props.user.username} name="username" title="Username input field" required />
            </FormGroup>
            <FormGroup>
              <Label>Email</Label>
              <Input defaultValue={this.props.user.email} key={this.props.user.email} name="email" title="Email address input field" required />
            </FormGroup>
            <Button color="primary" title="Button to submit username and email changes">Change User Name and Email</Button>
          </Form>
        </CollapsibleCard>
        <CollapsibleCard title='Password'>
          <Form onSubmit={this.handleChangePassword}>
            <FormGroup>
              <Label className='personalinfodata'> New Password </Label>
              <Input type="password" name="password" title="Password input field" required />
            </FormGroup>
            <FormGroup>
              <Label className='personalinfodata'> Confirm Password </Label>
              <Input type="password" name="confirmPassword" title="Confirm password input field" required />
            </FormGroup>
            <Button color="primary" title="Button to submit password change">Change Password</Button>
          </Form>
        </CollapsibleCard>
        <CollapsibleCard title='Security Questions'>
          <Form onSubmit={this.handleChangeSecurityQuestions}>
            <FormGroup>
              <Label>Question 1:</Label>
              <Input type="select" className="col-7 form-control"
                defaultValue={this.state.userQuestions.question1Id}
                key={this.state.userQuestions.question1Id}
                name="securityQuestion1"
                title="Security question 1 drop down"
              >
                {this.state.questions.map(q => <option value={q.questionid} key={q.questionid}>{q.question}</option>)}
              </Input>
              <PasswordField name="securityResponse1" title="Answer to security question 1 input field"
                defaultValue={this.state.userQuestions.answer1}
                key={this.state.userQuestions.answer1}
              />
            </FormGroup>
            <FormGroup>
              <Label>Question 2:</Label>
              <Input type="select" className="col-7 form-control"
                defaultValue={this.state.userQuestions.question2Id}
                key={this.state.userQuestions.question2Id}
                name="securityQuestion2"
                title="Security question 2 drop down"
              >
                {this.state.questions.map(q => <option value={q.questionid} key={q.questionid}>{q.question}</option>)}
              </Input>
              <PasswordField name="securityResponse2" title="Answer to security question 2 input field"
                defaultValue={this.state.userQuestions.answer2}
                key={this.state.userQuestions.answer2}
              />
            </FormGroup>
            <FormGroup>
                <Label>Question 3:</Label>
                <Input type="select" className="col-7 form-control"
                defaultValue={this.state.userQuestions.question3Id}
                key={this.state.userQuestions.question3Id}
                name="securityQuestion3"
                title="Security question 3 drop down"
                >
                {this.state.questions.map(q => <option value={q.questionid} key={q.questionid}>{q.question}</option>)}
              </Input>
              <PasswordField name="securityResponse3" title="Answer to security question 3 input field"
                defaultValue={this.state.userQuestions.answer3}
                key={this.state.userQuestions.answer3}
              />
            </FormGroup>
            <Button color='primary' title="Button to submit security question and response changes">Change Security Questions</Button>
          </Form>
        </CollapsibleCard>
      </TabPane>
    );
  }
}